// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b199c80f","732":"03831281","977":"a5d3df39"}[chunkId] + ".chunk.js";
};